import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class StaffPaperApprovals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      crew: 0,
      manager: 0,
      staff_paper_id: this.props.staff_paper_id,
      staff_paper_approvals: [],
      staff_paper: {},
      display_errors: false,
      errors: [],
    };

    this.locale = getLocale();

    //bind específico
    this.approveCrew = this.approveCrew.bind(this);
    this.approveManager = this.approveManager.bind(this);
    this.getInfoPaper = this.getInfoPaper.bind(this);
    this.confirmApproveCrew = this.confirmApproveCrew.bind(this);
    this.confirmApproveManager = this.confirmApproveManager.bind(this);
    this.reproveManager = this.reproveManager.bind(this);
    this.reopen = this.reopen.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && typeof newProps.staff_paper.month !== 'undefined' && Array.isArray(newProps.staff_paper_approvals)) {
      this.setState({
        staff_paper_id: newProps.staff_paper_id,
        staff_paper_approvals: newProps.staff_paper_approvals,
        staff_paper: newProps.staff_paper,
        loaded: 1,
      });
    }
  }

  // Modal para marcar como verificada
  approveCrew(schedule_grade_id){
    this.setState({crew: 1, manager: 0});
    this.getInfoPaper(schedule_grade_id);
  }

  // Modal para marcar como verificada
  approveManager(event){
    this.setState({manager: event, crew: 0});
    this.getInfoPaper(event);
  }

  getInfoPaper(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      id: self.state.staff_paper_id,
    };
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/tripulante/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            modal: true,
            url_export: url,
            iframe: 'iframe',
          });
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }
  

  confirmApproveCrew() {
    if (window.confirm(this.locale.Papeletas.EditarPapeleta.trocarStatus)){
      this.props.handleAlert('', '', 'open');

      var header = this.refs.request_api.header('application/json');
      var self = this;

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/tripulante/aprovar/' + self.state.staff_paper_id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          var staff_paper = { ...self.state.staff_paper };
          staff_paper.status = 1;
          self.setState({modal: false});
          if(responseJson.status === 'success') {
            self.setState({staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals});
          }
          if(responseJson.status === 'warning') {
            self.setState({display_errors: true, errors: responseJson.data});
          }
          if(responseJson.data.staff_paper_warnings) {
            self.props.changeParentState({staff_paper_warnings: responseJson.data.staff_paper_warnings});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  confirmApproveManager(event) {
    if (window.confirm(this.locale.Papeletas.EditarPapeleta.trocarStatus)){
      this.props.handleAlert('', '', 'open');

      var header = this.refs.request_api.header('application/json');
      var self = this;

      var datasave = {
        bypass_approval: event,
        id: self.state.staff_paper_id,
      };
        

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/gestor/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          var staff_paper = { ...self.state.staff_paper };
          staff_paper.status = 2;
          self.setState({modal: false});
          if(responseJson.status === 'success') {
            self.setState({staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals});
          }
          if(responseJson.data.staff_paper_warnings) {
            self.props.changeParentState({staff_paper_warnings: responseJson.data.staff_paper_warnings});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch salvando a edição
  reproveManager() {
    if (window.confirm(this.locale.Papeletas.EditarPapeleta.trocarStatus)){
      this.props.handleAlert('', '', 'open');

      var header = this.refs.request_api.header('application/json');
      var self = this;

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/gestor/reprovar/' + self.state.staff_paper_id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          var staff_paper = { ...self.state.staff_paper };
          staff_paper.status = 0;
          self.setState({modal: false});
          if(responseJson.status === 'success') {
            self.setState({staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals});
          }
          if(responseJson.data.staff_paper_warnings) {
            self.props.changeParentState({staff_paper_warnings: responseJson.data.staff_paper_warnings});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch salvando a edição
  reopen() {
    if (window.confirm(this.locale.Papeletas.EditarPapeleta.reabrir)){
      this.props.handleAlert('', '', 'open');

      var header = this.refs.request_api.header('application/json');
      var self = this;

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/reabrir/status/4/' + self.state.staff_paper_id, { method: 'PUT', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          var staff_paper = { ...self.state.staff_paper };
          staff_paper.status = responseJson.data.status;
          self.setState({staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals});
          if(responseJson.data.staff_paper_warnings) {
            self.props.changeParentState({staff_paper_warnings: responseJson.data.staff_paper_warnings});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;

    var approveButton = (
      <div className={'pull-right'}>
        <button onClick={() => self.approveManager(2)} className="btn button-inline btn-danger"><i className="fa fa-check"></i> {this.locale.Papeletas.EditarPapeleta.botaoForcarAprovacao}</button>
        <button onClick={() => self.approveCrew()} className="btn btn-primary pull-right"><i className="fa fa-check"></i> {this.locale.Papeletas.EditarPapeleta.botaoAprovacaoTripulante}</button>
      </div>
    );

    var managerButton = (
      <div className={'pull-right'}>
        <button onClick={() => self.approveManager(1)} className="btn button-inline btn-primary"><i className="fa fa-check"></i> {this.locale.Papeletas.EditarPapeleta.botaoAprovacaoGestor}</button>
      </div>
    );

    var approved = (
      <div className={'pull-right'}>
        <button onClick={() => self.reopen()} className="btn button-inline btn-danger"><i className="fa fa-close"></i> {this.locale.Papeletas.EditarPapeleta.botaoReabrirPapeleta}</button>
        <button className="btn button-inline btn-success" disabled><i className="fa fa-check"></i> {this.locale.Papeletas.EditarPapeleta.botaoPapeletaAprovada} </button>
      </div>
    );


    return (
<div>
  <RequestApi ref={'request_api'} />
  <hr/>
  <div>
    {
      self.state.display_errors && 
      <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
        <button onClick={() => self.setState({ display_errors: false, errors: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <strong>{this.locale.Papeletas.EditarPapeleta.erros}:</strong>
        {Object.keys(self.state.errors).map(function(k) {
          var message = self.state.errors[k];
          return (
            <p>- {message}</p>
          );
        })}
      </div>
    }
    <h4 className="pull-left">{this.locale.Papeletas.EditarPapeleta.tituloLogDeAprovacoes}</h4>
    {
      self.state.staff_paper.status === 0 && approveButton
    }
    {
      self.state.staff_paper.status === 1 && managerButton
    }
    {
      self.state.staff_paper.status === 2 && approved
    }
    <div className={'clearfix'}></div>
    <hr/>
    <div className="table-responsive">
      <table className="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th style={{width: '380px'}}>{this.locale.Papeletas.EditarPapeleta.tabelaLogDeAprovacoes.Usuario}</th>
            <th>{this.locale.Papeletas.EditarPapeleta.tabelaLogDeAprovacoes.Acao}</th>
            <th>{this.locale.Papeletas.EditarPapeleta.tabelaLogDeAprovacoes.Data}</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(self.state.staff_paper_approvals).map(function(k) {
            var spa = self.state.staff_paper_approvals[k];
            return (
              <tr>
                <td style={{width: '380px'}}>{spa.user_name}</td>
                <td>{spa.type}</td>
                <td>{spa.created_at_str}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
    <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
      <Modal.Header>
        <h4 className="pull-left">{this.locale.Papeletas.EditarPapeleta.tituloFIRA}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal: false})}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        {(self.state.crew === 1) ?  
          <div>
            <button onClick={() => self.confirmApproveCrew()} className="btn btn-success btn-block btn-lg"><i className="fa fa-check"></i> {this.locale.Papeletas.EditarPapeleta.botaoAprovacaoTripulante}</button>
          </div> 
        : ""
        }
        {(self.state.manager === 1) ?  
          <div>
            <button onClick={() => self.confirmApproveManager(0)} className="btn button-inline btn-success btn-block btn-lg"><i className="fa fa-check"></i> {this.locale.Papeletas.EditarPapeleta.botaoAprovacaoGestor}</button>
            <button onClick={() => self.reproveManager()} className="btn button-inline btn-danger btn-block btn-lg"><i className="fa fa-close"></i> {this.locale.Papeletas.EditarPapeleta.botaoReprovacaoGestor}</button>
          </div>
        : ""
        }
        {(self.state.manager === 2) ?  
          <div>
            <button onClick={() => self.confirmApproveManager(1)} className="btn button-inline btn-success btn-block btn-lg"><i className="fa fa-check"></i> {this.locale.Papeletas.EditarPapeleta.botaoAprovacaoGestor}</button>
          </div>
        : ""
        }

      <div>
        <hr/>
        <iframe className={this.state.iframe} height="600px" width="100%" src={this.state.url_export} name="iframe_a"></iframe>
      </div>

      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={() => this.setState({modal: false})}>
        <i className="fa fa-fw fa-close"></i></button>
      </Modal.Footer>
    </Modal>
  </div>
  <hr/>
</div>
    );
  }
}

export default StaffPaperApprovals;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/Elements/StaffPaperApprovals.js